// Compact header

// ON SCROLL



function manageScrolling(){
  const body = document.querySelector('body');
  var header = document.getElementById('header');
  var scrollPos = window.scrollY || window.scrollTop || document.querySelector('html').scrollTop;
  if (scrollPos < 50) {
    header.classList.remove('header--compact');
  } else {
    header.classList.add('header--compact');
  }  
}

window.addEventListener('scroll', manageScrolling);
manageScrolling();




// ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const leadCaptureHeroImage = document.querySelector('.layered-image--lead-capture-hero');
if(leadCaptureHeroImage) {

    gsap.fromTo(".background, .outside",
      { yPercent: 0, xPercent: 0 },
      {
        yPercent: -5,
        xPercent:0,
        scrollTrigger: {
          trigger: ".layered-image--lead-capture-hero",
          start: "top 0%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );

    gsap.fromTo(".outside-2",
      { yPercent: 0, rotation: 0 },
      {
        yPercent: -5,
        rotation:-15,
        scrollTrigger: {
          trigger: ".layered-image--lead-capture-hero",
          start: "top 0%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );

}

const leadCaptureHeroCrumbs = document.querySelector('.lead-capture-hero__crumbs');
if(leadCaptureHeroCrumbs) {
    gsap.fromTo(".lead-capture-hero__crumbs",
      { yPercent: 3 },
      {
        yPercent: -8,
        scrollTrigger: {
          trigger: ".lead-capture-hero__crumbs",
          start: "top 15%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );
}


const benefitsImage = document.querySelector('.layered-image--benefits');
if(benefitsImage) {
    gsap.fromTo(".background, .outside",
      { yPercent: 10, xPercent: 5 },
      {
        yPercent: -3,
        xPercent:-1,
        scrollTrigger: {
          trigger: ".layered-image--benefits",
          start: "top 80%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );
}

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});

/*
const scrollingTags = document.getElementById('scrolling-tags-track');
if(scrollingTags){
  gsap.fromTo("#scrolling-tags-track", { xPercent: 25 }, { xPercent: -25, duration: 40, ease: "none", repeat:-1 });
}
*/


// Shared variant ID for the free jar line item (used by both the Klaviyo signup
// redirect flow below and the Founder Subscribe / Just The Free Jar buttons)
var freeJarVariantId = 59703166402846;


// Coming Soon Signup form handling

window.addEventListener("klaviyoForms", async (event) => {

  if (event.detail.type !== "submit") return;

  if(event.detail.metaData?.$source == 'Coming Soon Signup' ){
    
    const email = event.detail.metaData?.$email;
    const dogName = event.detail.metaData?.["Dog Name"];

    const properties = btoa(
      JSON.stringify({ "Dog Name": dogName })
    )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

    window.location.href =
      `/cart/${freeJarVariantId}:1` +
      `?properties=${properties}` +
      `&checkout[email]=${encodeURIComponent(email)}`;

  }

});




// Automatically checks the founder_pricing checkbox
(function () {
  function checkFounderPricingBox() {
    const checkbox = document.querySelector('input[type="checkbox"][name^="founder_pricing_40"]');
    if (checkbox && !checkbox.checked) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }
    return false;
  }

  if (checkFounderPricingBox()) return;

  const observer = new MutationObserver(() => {
    if (checkFounderPricingBox()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 15000);
})();



// benefit items - active state as each item nears the vertical middle of the viewport
const benefitItems = document.querySelectorAll('.benefits__item');
if (benefitItems.length) {
  benefitItems.forEach((item) => {
    ScrollTrigger.create({
      trigger: item,
      start: 'top center+=10%',
      end: 'bottom center-=10%',
      toggleClass: { targets: item, className: 'benefits__item--active' }
    });
  });
}





// Coming Soon Hero - Flickity slider
const comingSoonSlider = document.querySelector('.coming-soon-hero__slider');
const comingSoonSliderNav = document.querySelector('.coming-soon-hero__slider-nav');
if (comingSoonSlider && comingSoonSliderNav && typeof Flickity !== 'undefined') {
  const comingSoonFlickityMain = new Flickity(comingSoonSlider, {
    cellSelector: '.coming-soon-hero__slide',
    pageDots: false,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    imagesLoaded: true
  });
  const comingSoonNavOptions = {
    cellSelector: '.coming-soon-hero__slide',
    asNavFor: comingSoonSlider,
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    groupCells: 5,
    imagesLoaded: true
  };
  let comingSoonFlickityNav = new Flickity(comingSoonSliderNav, comingSoonNavOptions);
  comingSoonSlider.addEventListener('rimg:load', () => {
    comingSoonFlickityMain.resize();
    comingSoonFlickityNav.resize();
  });

  const comingSoonMobileQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');
  let comingSoonNavWasHidden = comingSoonMobileQuery.matches;
  let comingSoonResizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(comingSoonResizeTimeout);
    comingSoonResizeTimeout = setTimeout(() => {
      const isHidden = comingSoonMobileQuery.matches;
      if (comingSoonNavWasHidden && !isHidden) {
        comingSoonFlickityNav.destroy();
        comingSoonFlickityNav = new Flickity(comingSoonSliderNav, comingSoonNavOptions);
      } else {
        comingSoonFlickityMain.resize();
        comingSoonFlickityNav.resize();
      }
      comingSoonNavWasHidden = isHidden;
    }, 150);
  });

  comingSoonFlickityMain.on('staticClick', (event, pointer, cellElement) => {
    if (cellElement) {
      comingSoonFlickityMain.next();
    }
  });
}


// Plan Selector - day supply sync
// Maps dog size (1 = under 25 lbs, 2 = 25-75 lbs, 3 = over 75 lbs) to:
//  - days:  how many days each jar tier (index 0 = 1 jar, 1 = 2 jars, 2 = 3 jars) lasts for that dog size
//  - plans: the variant + selling plan to add to cart for each jar tier ("1" | "2" | "3")
//           (variantId/sellingPlanId are placeholders - to be hardcoded later)

const subscriptionProduct1JarVariant = 59804307915038;
const subscriptionProduct2JarVariant = 59804307947806;
const subscriptionProduct3JarVariant = 59804307980574;

const subscriptionProductStarter1JarVariant = 59819466686750;
const subscriptionProductStarter2JarVariant = 59819466719518;
const subscriptionProductStarter3JarVariant = 59819466752286;

var planDetails = {
  "1": {
    "days": [60, 120, 180],
    "plans": {
      "1": { "variantId": subscriptionProductStarter1JarVariant, "sellingPlanId": 10072785182 },
      "2": { "variantId": subscriptionProductStarter2JarVariant, "sellingPlanId": 10072850718 },
      "3": { "variantId": subscriptionProductStarter3JarVariant, "sellingPlanId": 10072883486 }
    }
  },
  "2": {
    "days": [30, 60, 90],
    "plans": {
      "1": { "variantId": subscriptionProductStarter1JarVariant, "sellingPlanId": 10072719646 },
      "2": { "variantId": subscriptionProductStarter2JarVariant, "sellingPlanId": 10072785182 },
      "3": { "variantId": subscriptionProductStarter3JarVariant, "sellingPlanId": 10072817950 }
    }
  },
  "3": {
    "days": [20, 40, 60],
    "plans": {
      "1": { "variantId": subscriptionProductStarter1JarVariant, "sellingPlanId": 10072686878 },
      "2": { "variantId": subscriptionProductStarter2JarVariant, "sellingPlanId": 10072752414 },
      "3": { "variantId": subscriptionProductStarter3JarVariant, "sellingPlanId": 10072785182 }
    }
  }
};

function getPlanDaysForJarTier(dogSize, jarTier) {
  var sizeConfig = planDetails[String(dogSize)];
  if (!sizeConfig) return null;
  var dayIndex = Number(jarTier) - 1;
  return sizeConfig.days[dayIndex];
}

function getPlanDetailsForSelection(dogSize, jarTier) {
  var sizeConfig = planDetails[String(dogSize)];
  if (!sizeConfig) return null;
  return sizeConfig.plans[String(jarTier)] || null;
}

const planDaySupplyEls = document.querySelectorAll('[data-plan-days]');

function updatePlanDaySupply(dogSize) {
  if (!planDaySupplyEls.length) return;
  planDaySupplyEls.forEach(function (el) {
    var jarTier = el.dataset.planDays;
    var days = getPlanDaysForJarTier(dogSize, jarTier);
    if (days != null) {
      el.textContent = days + '-Day Supply';
    }
  });
}

// ============================================================
// Cross-Widget Sync — Dog Size & Jar Tier (single source of truth)
// ------------------------------------------------------------
// Three widgets let the shopper pick "dog size" and/or "jar tier / supply
// length", each with its own markup + vocabulary:
//   - .weight-selector                       -> numeric "1"|"2"|"3"   (dog size)
//   - .coming-soon-hero__product-radio       -> numeric "1"|"2"|"3"   (jar tier)
//   - .sticky-product-widget [data-dog-size]  -> numeric "1"|"2"|"3"  (dog size, bridged via Liquid data attrs)
//   - .sticky-product-widget [data-jar-tier]  -> numeric "1"|"2"|"3"  (jar tier, bridged via Liquid data attrs)
//
// setDogSize(value) / setJarTier(value) are the ONLY functions allowed to
// write to more than one widget's DOM. Every event handler below (range
// input, icon/label click, radio change, sticky-widget option click) calls
// INTO one of these two functions instead of reaching into a sibling widget
// directly - event -> setX() -> [DOM writes], never widget-A -> widget-B -> widget-A.
// Each setX() also short-circuits if the value hasn't actually changed.
// ============================================================

let currentDogSize = null;
let currentJarTier = null;

const dogSizeWeightText = { '1': 'under 25 pounds', '2': '25 to 75 pounds', '3': 'over 75 pounds' };
const dogSizeStickyLabel = { '1': 'UNDER 25 LBS', '2': '25–75 LBS', '3': 'OVER 75 LBS' };

// ------------------------------------------------------------
// Weight Selector - tail wag (Web Animations API)
// Wags a dog icon's tail whenever its .icon-btn becomes the active
// (selected) size, driven by setDogSize() below - not by click, so it
// stays correct no matter which widget changed the dog size.
// ------------------------------------------------------------
const TAIL_REST_ANGLE = 0;   // matches the resting rotation set in bk-styles.css

// Per-size wag specs from design: "Total Round-Trip Rotation" is the full
// peak-to-peak swing (so amplitude is half of it), "Loop Keyframe Count" is
// converted to a loop duration assuming 60fps (count / 60 * 1000ms). `duration`
// is the time for one full rest->peak->trough->rest cycle (see TAIL_WAG_CURVE).
const TAIL_WAG_CONFIG = {
  '1': { amplitude: 28 / 2, duration: 20 / 60 * 1000 }, // small: 28°, 18 keyframes @60fps = 300ms
  '2': { amplitude: 45 / 2, duration: 30 / 60 * 1000 }, // medium: 35°, 30 keyframes @60fps = 500ms
  '3': { amplitude: 32 / 2, duration: 24 / 60 * 1000 }  // large: 32°, 24 keyframes @60fps = 400ms
};

// Shape of one wag loop cycle, eyeballed from the AE graph-editor export (fast rise to
// peak, slower swing through center into a deeper trough, easing back to rest) - offsets
// are fractions of one loop's duration; tune these against the AE reference if needed.
const TAIL_WAG_CURVE = {
  peakOffset: 0.2,     // frame ~6/30 in the AE graph
  troughOffset: 0.65,  // frame ~20/30 in the AE graph
  riseEasing: 'cubic-bezier(0.16, 1, 0.3, 1)',     // quick, decelerating into the peak cubic-bezier(0.16, 1, 0.3, 1)
  fallEasing: 'cubic-bezier(.66,.5,1,1)',    // smooth traverse through center to the trough cubic-bezier(0.45, 0, 0.55, 1)
  returnEasing: 'cubic-bezier(0.33, 1, 0.68, 1)'   // gentle settle back to rest
};

const tailControllers = new Map(); // .icon-btn -> { setActive }

function getTailRotation(el) {
  const transform = getComputedStyle(el).transform;
  if (transform === 'none') return TAIL_REST_ANGLE;
  const matrix = new DOMMatrixReadOnly(transform);
  return Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);
}

function createTailController(tailEl, amplitude, loopDuration) {
  let currentAnim = null;
  let isActive = false;

  function startWag() {
    const current = getTailRotation(tailEl);
    if (currentAnim) currentAnim.cancel();

    const enter = tailEl.animate(
      [
        { transform: `rotate(${current}deg)` },
        { transform: `rotate(${TAIL_REST_ANGLE}deg)` }
      ],
      { duration: 220, easing: 'ease-in-out', fill: 'forwards' }
    );
    currentAnim = enter;

    enter.finished.then(function () {
      if (currentAnim !== enter) return; // interrupted before it landed
      currentAnim = tailEl.animate(
        [
          { transform: `rotate(${TAIL_REST_ANGLE}deg)`, offset: 0, easing: TAIL_WAG_CURVE.riseEasing },
          { transform: `rotate(${amplitude}deg)`, offset: TAIL_WAG_CURVE.peakOffset, easing: TAIL_WAG_CURVE.fallEasing },
          { transform: `rotate(${-amplitude}deg)`, offset: TAIL_WAG_CURVE.troughOffset, easing: TAIL_WAG_CURVE.returnEasing },
          { transform: `rotate(${TAIL_REST_ANGLE}deg)`, offset: 1 }
        ],
        { duration: loopDuration, iterations: Infinity }
      );
    }).catch(function () {});
  }

  function stopWag() {
    const current = getTailRotation(tailEl);
    if (currentAnim) currentAnim.cancel();

    currentAnim = tailEl.animate(
      [
        { transform: `rotate(${current}deg)` },
        { transform: `rotate(${TAIL_REST_ANGLE}deg)` }
      ],
      { duration: 350, easing: 'ease-out', fill: 'forwards' }
    );
  }

  return {
    setActive: function (active) {
      if (active === isActive) return;
      isActive = active;
      active ? startWag() : stopWag();
    }
  };
}

function setDogSize(value) {
  value = String(value);
  if (!dogSizeWeightText[value]) return;
  if (currentDogSize === value) return;
  currentDogSize = value;

  // 1) Weight Selector - range + icon/label buttons
  const weightRange = document.getElementById('dog-size');
  if (weightRange) {
    weightRange.value = value;
    weightRange.setAttribute('aria-valuetext', dogSizeWeightText[value]);
    document.querySelectorAll('.weight-selector .icon-btn').forEach(function (btn) {
      const isActive = btn.dataset.value === value;
      btn.classList.toggle('active', isActive);
      const tailCtrl = tailControllers.get(btn);
      if (tailCtrl) { tailCtrl.setActive(isActive); }
    });
    document.querySelectorAll('.weight-selector .label-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.value === value);
    });
  }

  // 2) Sticky widget - dog-size dropdown
  const dogSizeField = document.querySelector('.dropdown-field[data-field="dogSize"]');
  if (dogSizeField) {
    const option = dogSizeField.querySelector('[data-dog-size="' + value + '"]');
    if (option) {
      dogSizeField.querySelectorAll('[role="option"]').forEach(function (o) { o.removeAttribute('aria-selected'); });
      option.setAttribute('aria-selected', 'true');
      const selectedLabel = dogSizeField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = dogSizeStickyLabel[value]; }

      const selectedIcon = dogSizeField.querySelector('[data-role="selected-icon"]');
      const optionIcon = option.querySelector('.dropdown-option-icon');
      if (selectedIcon && optionIcon) { selectedIcon.innerHTML = optionIcon.innerHTML; }
    }
  }

  // 3) Downstream day-supply labels that depend on dog size
  updatePlanDaySupply(value);        // .coming-soon-hero__product-days spans
  updateStickySupplyLabels(value);   // sticky widget's supply <li> day-counts
}

function setJarTier(value) {
  value = String(value);
  if (!['1', '2', '3'].includes(value)) return;
  if (currentJarTier === value) return;
  currentJarTier = value;

  // 1) Coming Soon Hero jar-tier radios
  const radio = document.querySelector('.coming-soon-hero__product-radio[value="' + value + '"]');
  if (radio) { radio.checked = true; }

  // 2) Sticky widget - supply dropdown
  const supplyField = document.querySelector('.dropdown-field[data-field="supply"]');
  if (supplyField) {
    const option = supplyField.querySelector('[data-jar-tier="' + value + '"]');
    if (option) {
      supplyField.querySelectorAll('[role="option"]').forEach(function (o) { o.removeAttribute('aria-selected'); });
      option.setAttribute('aria-selected', 'true');
      const selectedLabel = supplyField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = option.dataset.label; }

      const selectedPrice = supplyField.querySelector('[data-role="selected-price"]');
      const priceStrong = option.querySelector('.option-price strong');
      if (selectedPrice && priceStrong) { selectedPrice.textContent = priceStrong.textContent; }
    }
  }
}

// When dog size changes, refresh the sticky widget's supply option day-counts
// from planDetails (reuses getPlanDaysForJarTier - no duplicated day-math).
function updateStickySupplyLabels(dogSize) {
  const supplyField = document.querySelector('.dropdown-field[data-field="supply"]');
  if (!supplyField) return;

  supplyField.querySelectorAll('[data-jar-tier]').forEach(function (option) {
    const jarTier = option.dataset.jarTier;
    const days = getPlanDaysForJarTier(dogSize, jarTier);
    if (days == null) return;

    const newLabelText = days + '-DAY SUPPLY';
    option.dataset.label = newLabelText;

    const textSpan = option.querySelector('span:last-child');
    if (textSpan) { textSpan.textContent = newLabelText; }

    if (option.getAttribute('aria-selected') === 'true') {
      const selectedLabel = supplyField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = newLabelText; }
    }
  });
}


// Weight Selector
const weightSelector = document.querySelector('.weight-selector');
if (weightSelector) {
  const weightRange = weightSelector.querySelector('#dog-size');
  const weightIconBtns = weightSelector.querySelectorAll('.icon-btn');
  const weightLabelBtns = weightSelector.querySelectorAll('.label-btn');

  weightIconBtns.forEach(function (btn) {
    const tailEl = btn.querySelector('.tail');
    const config = TAIL_WAG_CONFIG[btn.dataset.value];
    if (tailEl && config) {
      tailControllers.set(btn, createTailController(tailEl, config.amplitude, config.duration));
    }
  });

  weightRange.addEventListener('input', () => setDogSize(weightRange.value));

  weightIconBtns.forEach(btn => btn.addEventListener('click', () => setDogSize(btn.dataset.value)));
  weightLabelBtns.forEach(btn => btn.addEventListener('click', () => setDogSize(btn.dataset.value)));

  // Initial sync: reconciles all three widgets to whatever the range's value is today.
  setDogSize(weightRange.value);
}

// Coming Soon Hero - Jar Tier radios
const jarTierRadios = document.querySelectorAll('.coming-soon-hero__product-radio');
if (jarTierRadios.length) {
  jarTierRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (radio.checked) { setJarTier(radio.value); }
    });
  });

  // Initial sync: whichever radio is checked in the DOM today.
  const checkedJarTierRadio = document.querySelector('.coming-soon-hero__product-radio:checked');
  if (checkedJarTierRadio) { setJarTier(checkedJarTierRadio.value); }
}

// Sticky Product Widget - toggle open/closed
const stickyProductWidget = document.getElementById('sticky-product-widget');
const stickyProductWidgetToggles = document.querySelectorAll('.toggle-sticky-product-widget');
if (stickyProductWidget && stickyProductWidgetToggles.length) {
  stickyProductWidgetToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const isOpen = stickyProductWidget.dataset.status === 'open';
      stickyProductWidget.dataset.status = isOpen ? 'closed' : 'open';
    });
  });
}

// Sticky Product Widget - open it when a #product-widget link is clicked on mobile
const productWidgetLinks = document.querySelectorAll('a[href="#product-widget"]');
if (stickyProductWidget && productWidgetLinks.length) {
  const mobilePortraitQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');
  productWidgetLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      if (mobilePortraitQuery.matches) {
        stickyProductWidget.dataset.status = 'open';
      }
    });
  });
}

// Sticky Product Widget - open when the #coming-soon-hero is off screen
const comingSoonHeroSection = document.getElementById('coming-soon-hero');
if (stickyProductWidget && comingSoonHeroSection) {
  ScrollTrigger.create({
    trigger: comingSoonHeroSection,
    start: 'bottom 60%',
    onEnter: function () {
      stickyProductWidget.dataset.status = 'open';
    },
    onLeaveBack: function () {
      stickyProductWidget.dataset.status = 'hidden';
    }
  });
}

// Sticky Product Widget - dropdown open/close (ported from its former inline
// <script>) + option selection (delegates to the shared setDogSize()/setJarTier()
// functions above instead of writing to a local state object).
document.querySelectorAll('.dropdown-field').forEach(function (field) {
  const fieldName = field.dataset.field; // "dogSize" | "supply"
  const trigger = field.querySelector('.dropdown-trigger');
  const panel = field.querySelector('.dropdown-panel');
  const options = field.querySelectorAll('[role="option"]');

  trigger.addEventListener('click', function () {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      if (fieldName === 'dogSize' && option.dataset.dogSize) {
        setDogSize(option.dataset.dogSize);
      } else if (fieldName === 'supply' && option.dataset.jarTier) {
        setJarTier(option.dataset.jarTier);
      }

      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
  });
});

// Close dropdowns when clicking outside
document.addEventListener('click', function (e) {
  document.querySelectorAll('.dropdown-field').forEach(function (field) {
    if (!field.contains(e.target)) {
      field.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
      field.querySelector('.dropdown-panel').hidden = true;
    }
  });
});




// Coming Soon Hero - Plan Selector cart buttons
// Adds the selected subscription line item (and/or the free jar) to the cart via
// a standalone /cart/add.js fetch call, then redirects to checkout on success.

function cartGetSelectedDogSize() {
  const dogSizeInput = document.getElementById('dog-size');
  return dogSizeInput ? dogSizeInput.value : '2';
}

function cartGetSelectedJarTier() {
  const checkedRadio = document.querySelector('.coming-soon-hero__product-radio:checked');
  return checkedRadio ? checkedRadio.value : null;
}

function cartAddToCart(items) {

  // alert(JSON.stringify(items));

  // clear cart
  return fetch('/cart/clear.js', { method: 'POST' }).then(function () {

    // add items to cart
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {

      return response.json().then(function (data) {

        // throw any errors
        if (!response.ok) {
          const errorMessage = (data && (data.description || data.message)) || 'Something went wrong adding this to your cart.';
          throw new Error(errorMessage);
        }

        // early return for only Free Jar
        if(items.length == 1 && items[0].id == freeJarVariantId){
          return data;
        }        

        // update cart with dog_size
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              dog_size: dogSizes[cartGetSelectedDogSize()],
              jar_count: cartGetSelectedJarTier()
            }
          })
        }).then(function (updateResponse) {

          return updateResponse.json().then(function (updatedCart) {
            if (!updateResponse.ok) {
              throw new Error('Something went wrong updating the cart.');
            }

            // console.log('Updated cart:', updatedCart);
            console.log('updatedCart.attributes.dog_size:', updatedCart.attributes.dog_size);

            return updatedCart;
          });

        });

      });

    });
  });
}

function cartHandleAddToCartError(error) {
  console.error('Cart add error:', error);
  alert(error.message || 'Something went wrong adding this to your cart. Please try again.');
}

function cartRedirectToCheckout() {
  window.location.href = '/checkout';
}

const founderSubscribeButtons = document.querySelectorAll('.founder-subscribe');
founderSubscribeButtons.forEach(function (founderSubscribeButton) {
  founderSubscribeButton.addEventListener('click', function (event) {
    event.preventDefault();

    const includeFreeJar = founderSubscribeButton.dataset.includeFreeJar === 'true' ? true : false;
    const dogSize = cartGetSelectedDogSize();
    const jarTier = cartGetSelectedJarTier();
    const selectedPlan = jarTier ? getPlanDetailsForSelection(dogSize, jarTier) : null;

    if (!selectedPlan || !selectedPlan.variantId) {
      cartHandleAddToCartError(new Error('Please select a plan before subscribing.'));
      return;
    }

    const subscriptionItem = { id: selectedPlan.variantId, quantity: 1 };
    if (selectedPlan.sellingPlanId) {
      subscriptionItem.selling_plan = selectedPlan.sellingPlanId;
    }

    const itemsForCart = [subscriptionItem]
    if(includeFreeJar){
      itemsForCart.push({ id: freeJarVariantId, quantity: 1 })
    }
    
    cartAddToCart(itemsForCart)
      .then(cartRedirectToCheckout)
      .catch(cartHandleAddToCartError);
  });
});

const justFreeJarButtons = document.querySelectorAll('.just-free-jar');
justFreeJarButtons.forEach(function (justFreeJarButton) {
  justFreeJarButton.addEventListener('click', function (event) {
    event.preventDefault();

    cartAddToCart([
      { id: freeJarVariantId, quantity: 1 }
    ])
      .then(cartRedirectToCheckout)
      .catch(cartHandleAddToCartError);
  });
});



const dogSizes = {
  '1': 'small',
  '2': 'medium',
  '3': 'large'
};